import type { CustomTranslateKey } from '@/basket/types/i18n';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import type { Icon } from '@phosphor-icons/react';
import { useTranslations } from 'next-intl';

interface Props {
  Icon: Icon;
  text: string;
}

export const Benefit = ({ Icon, text }: Props) => {
  const t = useTranslations('login.benefits');

  return (
    <div className="flex gap-xs no-flex-gap:space-x-xs">
      <PhosphorIcon
        Icon={Icon}
        className="icon-m w-m min-w-m max-w-m text-brandMain"
      />
      <span className="text-body text-default">
        {t(text as CustomTranslateKey)}
      </span>
    </div>
  );
};
